import React from 'react'
import { SLOTS_ROUTE_PATHS, SlotsModule } from '@bcraft-frontend-lib/slots'
import block from 'bem-cn'
import { motion } from 'framer-motion'

import { CarouselSlider } from 'components/CarouselSlider/CarouselSlider'
import SlotsLayoutContent from 'components/slots/SlotsLayoutContent'

import { SlotPlace } from './redefinitions'

import './components/SlotsLayout/SlotsLayout.scss'

const b = block('slots-layout')

export class SlotsLayoutModule {
  getRoutes() {
    return (
      <SlotsModule<SlotPlace>
        key={SLOTS_ROUTE_PATHS.SLOTS}
        path={SLOTS_ROUTE_PATHS.SLOTS}
        render={slotsProps => (
          <motion.div
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className={b('wrapper')}>
            <CarouselSlider />
            <SlotsLayoutContent {...slotsProps} />
          </motion.div>
        )}
      />
    )
  }
}
